// extracted by mini-css-extract-plugin
export default {"PageHeader":"_3KWeUbVN3vcM5TxDVc+7YQ==","NoMargin":"Z7nEeqcSLGqo0oZD8Ne-nA=="};